<div style="padding-top:10px">
    {{login}}
</div>

<div class="jumbotron">
    <ng-template #welcomeUser>
        <h4>Welcome to OneDrive </h4>
    </ng-template>
</div>